<template>
    <div class="col" :class="filterClass">
        <div v-if="filter" class="filter-box">
            <p class="title">Filter</p>
            <Select2 v-if=" type === 'select'" :options="options" v-model="searchParam" placeholder="Terminal"  name="select" class="select select-search" data-placeholder="Select Terminal"/>
            <input v-if=" type === 'input'" class="form-control" v-model="searchParam"/>
            <filter-date v-if="type === 'date'" v-model="searchParam"/>
            <div class="btn-box">
                <span class="btn success submit" @click.prevent="filterClick">Submit</span>
                <span @click.prevent="btnFilterClick" class="btn light-green close reset">Cancel</span>
            </div>
        </div>
        <div v-if="filter" @click="btnFilterClick" class="filter-icon">
            <icon-base width="19" height="13" viewBox="0 0 19 13"><icon-filter/></icon-base>
        </div>
        <div class="status-box" v-if="status" @click="filterClick">
            <icon-base width="10" height="17" viewBox="0 0 10 17" icon-name="updown">
                <icon-up-down/>
            </icon-base>
            <p class="title-col">Status</p>
        </div>
        <p v-if="!status" class="title-col" @click="filterClick">{{label}}</p>
        <icon-base v-if="!status" width="10" height="17" viewBox="0 0 10 17"><icon-up-down/></icon-base>
    </div>
</template>

<script>

import IconBase from "./IconBase";
import IconUpDown from "./icons/IconUpDown";
import IconFilter from "./icons/IconFilter";
import Select2 from "../Client/MySelect2";
import FilterDate from "./FilterDate";
export default {
    name: 'simple-table-filter',

    props: {
        name: String,
        label: String,
        options: Array,
        param: String,
        filter: {
            type: Boolean,
            default: false
        },
        select: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'input'
        },
        status: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return{
            orderBy: false,
            filterClass: this.name + '-col',
            filterOpen: false,
            searchParam: ''
        }
    },

    components: {FilterDate, Select2, IconFilter, IconUpDown,  IconBase},
    watch: {
        param: function() {
            this.defineFilterClass();
        }
    },

    methods: {
        defineFilterClass() {
            if (this.param !== this.name) {
                this.filterClass = this.name + '-col ';
            } else {
                this.filterClass = this.name + '-col ' + (this.orderBy ? 'filter-up' : 'filter-down')
            }

            if (this.filterOpen) {
                this.filterClass += ' visible-filter-box'
            }
        },
        filterClick() {
            if (!this.searchParam) this.orderBy = !this.orderBy;
            this.filterOpen = false;
            this.defineFilterClass();
            this.$emit('filter', {name: this.name, order: this.orderBy, search: this.searchParam})
        },
        /*searchFilterClick() {
            this.orderBy = !this.orderBy;
            this.defineFilterClass();
            this.$emit('searchFilter', {search: this.searchParam})
        },*/
        btnFilterClick() {
            this.filterOpen = !this.filterOpen;
            this.defineFilterClass();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
